import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Tooltip.css';

const Tooltip = ({ children, text, position = 'top' }) => {
  const [coords, setCoords] = useState(null);
  const containerRef = useRef(null);

  const handleMouseEnter = () => {
    if (!containerRef.current || !text) return;
    const rect = containerRef.current.getBoundingClientRect();
    setCoords({
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height
    });
  };

  const handleMouseLeave = () => setCoords(null);

  const getTooltipStyle = () => {
    if (!coords) return {};
    const gap = 8;
    const base = {
      position: 'fixed',
      zIndex: 10000,
      padding: '8px 12px',
      fontSize: '12px',
      borderRadius: '6px',
      whiteSpace: 'normal',
      maxWidth: '220px',
      lineHeight: 1.4,
      fontWeight: 500,
      boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
      pointerEvents: 'none'
    };
    if (position === 'right') {
      return { ...base, top: coords.top + coords.height / 2, left: coords.left + coords.width + gap, transform: 'translateY(-50%) translateX(4px)' };
    }
    if (position === 'left') {
      return { ...base, top: coords.top + coords.height / 2, right: window.innerWidth - coords.left + gap, left: 'auto', transform: 'translateY(-50%) translateX(-4px)' };
    }
    if (position === 'bottom') {
      return { ...base, top: coords.top + coords.height + gap, left: coords.left + coords.width / 2, transform: 'translateX(-50%) translateY(4px)' };
    }
    // top (default)
    return { ...base, top: coords.top - gap, left: coords.left + coords.width / 2, transform: 'translateX(-50%) translateY(calc(-100% - 4px))' };
  };

  const tooltipEl = coords && text && createPortal(
    <span className="tooltip tooltip-portal" style={getTooltipStyle()}>{text}</span>,
    document.body
  );

  return (
    <div
      ref={containerRef}
      className={`tooltip-container tooltip-${position}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
      {tooltipEl}
    </div>
  );
};

export default Tooltip;
